import { usePlanogramQuery } from "@/shared/api";
import { Bins } from "@/virtual-store/planogram/bins";
import { Gondolas } from "@/virtual-store/planogram/gondolas";
import { useSchedules } from "@/virtual-store/hooks/useSchedules";

export function Planogram() {
  const { activeSchedule } = useSchedules({ queryKey: "planogramSchedules" });

  const { data: planogram } = usePlanogramQuery(
    {
      id: activeSchedule?.id!,
    },
    {
      skip: !activeSchedule,
    }
  );

  if (!planogram) return null;

  return (
    <>
      <Gondolas planogram={planogram} />
      <Bins planogram={planogram} />
    </>
  );
}
